import Text from "../../Text";
import { StepProps } from "../types";
import { StepCounterStyled, StepStyled } from "./Step.styled";
import type { FC } from "react";
import { memo } from "react";
import { WithStyle } from "utils/WithStyle";

const Component: FC<StepProps> = memo((props) => {
    const {
        step,
        children,
        onClick,
        fullWidth = false,
        totalSteps = 0,
        size = 'S',
        ...restProps
    } = props;

    return (
        <StepStyled {...{ onClick, fullWidth, totalSteps, size }}>
            <StepCounterStyled {...restProps} />
            {children && <Text variant="label">{children}</Text>}
        </StepStyled>
    );
});

Component.displayName = "Step";
const Step: FC<StepProps> & WithStyle = Object.assign(Component, {
    Style: StepStyled,
});
export default Step;
